import { Tooltip } from "components/Tooltips/Tooltip";
import { useIsOverflown } from "hooks/useIsOverflown";
import React from "react";
import { useStyles } from "./SegmentConditions.styles";

export function BoxElement({
  content,
  error = "",
}: {
  content: string | React.ReactElement;
  error?: string;
}) {
  const classes = useStyles();
  const { observeElement, isOverflown } = useIsOverflown();

  return (
    <Tooltip text={error}>
      <Tooltip
        text={content}
        disableHoverListener={!isOverflown}
        placement="bottom-start"
      >
        <div
          className={`${classes.box} ${error && classes.error}`}
          ref={observeElement}
          id="boxElement"
        >
          {content}
        </div>
      </Tooltip>
    </Tooltip>
  );
}
